import getRoomsInternalOperation from 'owa-service/lib/operation/getRoomsInternalOperation';
import type RoomType from 'owa-service/lib/contract/RoomType';

/**
 * Calls getRoomsInternalService to get Rooms for a given room smtp
 */
export default function getRoomsInternalService(roomSmtp: string): Promise<RoomType[]> {
    return getRoomsInternalOperation({
        roomList: roomSmtp,
    });
}
